import React from "react";

const CurrencyHelper = {
  GetCurrencySymbolHelper: (data) => {
    switch (data) {
      case "try":
        return " ₺";
      case "tl":
        return " ₺";
      case "usd":
        return " $";
      case "eur":
        return " €";
      case "aud":
        return " AU$";
      case "chf":
        return " CHF";
      case "cny":
        return " ¥";
      case "jpy":
        return " ¥";
      case "gbp":
        return " £";
      case "dkk":
        return " DKK";
      default:
        return "";
    }
  },
};

export { CurrencyHelper };
